import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Heading,
  Text,
  Alert,
  AlertIcon,
  AlertDescription,
  Spinner,
  Progress,
  InputGroup,
  InputRightElement,
  Center,
  Image,
  HStack,
  Link,
  Tooltip,
} from "@chakra-ui/react";
import { useAppContext } from "../context/AppContext";
import { useNavigate } from "react-router-dom";
import { validCredentials } from "../helpers/mock/validCredentials-mock";
import { getToken } from "../api/get-token-api";
import { getAllFileNames } from "../api/get-files-name-jc-api";
import { getAllItemsPex } from "../api/get-items-pex-api";
import { getAllItemsPexWithPoints } from "../api/get-items-pontuacao-api";
import { FaExternalLinkAlt, FaEye, FaEyeSlash } from "react-icons/fa";
import { distCredentials } from "../helpers/mock/validCredentials-mock";
import { useMsal } from "@azure/msal-react";
import { FaSignInAlt } from "react-icons/fa";
import { getActiveYear } from "../api/get-active-year";
import PexBG from "../helpers/mock/files/pex-img-teste123.png";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0); // Adicionado estado para a barra de progresso
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false); // Estado para controlar a visibilidade da senha
  const { distribuidor, setDistribuidorGlobal } = useAppContext();
  const { globalToken, setGlobalToken } = useAppContext();
  const { user, setUser } = useAppContext();
  const { userProfile, setUserProfile } = useAppContext();
  const { getFileNameAnualApiGlobalState, setGetFileNameAnualApiGlobalState } =
    useAppContext();
  const {
    getFileNameTrimestralApiGlobalState,
    setGetFileNameTrimestralApiGlobalState,
  } = useAppContext();
  const { emailGlobal, setEmailGlobal } = useAppContext();
  const { passwordGlobal, setPasswordGlobal } = useAppContext();
  const { getItemsPexGlobalState, setGetItemsPexGlobalState } = useAppContext();
  const { getItemsPontuacaoAnualApi, setGetItemsPontuacaoAnualApi } =
    useAppContext();
  const { getItemsPontuacaoTrimestralApi, setGetItemsPontuacaoTrimestralApi } =
    useAppContext();
  const { anoGlobal, setAnoGlobal } = useAppContext();
  const { trimestreGlobal, setTrimestreGlobal } = useAppContext();
  const { anoGlobalAtivo, setAnoGlobalAtivo } = useAppContext();
  const { trimestreGlobalAtivo, setTrimestreGlobalAtivo } = useAppContext();

  const { emailUsuario, setEmailUsuario } = useAppContext();
  const { acessoUsuario, setAcessoUsuario } = useAppContext();
  const { nivelAcesso, setNivelAcesso } = useAppContext();
  const { empresaGlobal, setEmpresaGlobal } = useAppContext();
  const { statusGlobal, setStatusGlobal } = useAppContext();

  const { instance } = useMsal();

  const initializeSignIn = () => {
    instance.loginRedirect();
  };

  const rainStyle = `
  body {
    margin: 0;
    overflow: hidden;
    filter: grayscale(1);
  }

  .rain {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 0;
    background-image: linear-gradient(
      rgba(255,255,255,0.05) 1px, transparent 1px
    );
    background-size: 1px 15px;
    animation: rain 0.5s linear infinite;
  }

  @keyframes rain {
    0% { background-position: 0 0; }
    100% { background-position: 0 15px; }
  }
`;

  useEffect(() => {
    const checkAuth = async () => {
      try {
        setLoading(true);

        const storedProfile = userProfile;

        if (storedProfile) {
          setUserProfile(storedProfile);

          // Se o usuário estiver autenticado, redirecione para a página apropriada
          switch (storedProfile) {
            case "Avaliador":
              navigate("/avaliador");
              break;
            case "Administrador":
              navigate("/periodo-avaliacao");
              break;
            // Adicione outros casos conforme necessário

            default:
              navigate("/evidencias");
          }
        }
      } catch (error) {
        setError("Erro ao verificar autenticação. Tente novamente.");
        console.error("Erro em checkAuth:", error);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  useEffect(() => {
    const root = document.getElementById("root");
    if (root) {
      root.style.filter = "grayscale(1)";
    }

    return () => {
      if (root) {
        root.style.filter = "none"; // remove filtro ao sair da página
      }
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const tokenzao = await getToken(email, password);

      if (tokenzao.code !== 401) {
        setGlobalToken(tokenzao.access_token);
        const getAnoAtivo = await getActiveYear(tokenzao.access_token);
        setAnoGlobal(getAnoAtivo.ano);
        setTrimestreGlobal(getAnoAtivo.referencia);
        setAnoGlobalAtivo(getAnoAtivo.ano);
        setTrimestreGlobalAtivo(getAnoAtivo.referencia);
        setStatusGlobal(getAnoAtivo.status);
        handleLogin();
      } else {
        setError("Credenciais inválidas. Tente novamente.");
      }
    } catch (error) {
      console.error("Ocorreu um erro durante a execução do código:", error);
      setError(
        "Ocorreu um erro durante o processo. Tente novamente mais tarde."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = () => {
    setEmailGlobal(email.toLowerCase());
    setPasswordGlobal(password);
    const normalizedEmail = email.toLowerCase();

    let user = validCredentials.find(
      (u) => u.email.toLowerCase() === normalizedEmail
    );

    if (!user) {
      user = distCredentials.find(
        (u) => u.email.toLowerCase() === normalizedEmail
      );
    }

    if (user) {
      setError(null);

      setEmpresaGlobal(user.empresa);

      setUser(user.email);

      setUserProfile(user.profile);

      setAcessoUsuario(user.access);

      setNivelAcesso(user.nivelAvaliador);

      // Armazenar o perfil de usuário no armazenamento local
      // localStorage.setItem("userProfile", user.profile);
      // localStorage.setItem("userEmail", user.email);
      // Armazenar os acessos do usuário no armazenamento local
      // localStorage.setItem("userAccess", JSON.stringify(user.access));
      // localStorage.setItem("userNivelAcess", user.nivelAvaliador);

      if (user.profile === "Avaliador") {
        navigate("/avaliador");
      } else if (user.profile === "Administrador") {
        setDistribuidorGlobal("FORMULA");

        navigate("/periodo-avaliacao");
      } else {
        // Definir o distribuidor no estado global
        setDistribuidorGlobal(user.empresa);
        navigate("/evidencias");
        // Tratar outros perfis, se necessário
      }
    } else {
      setError("Credenciais inválidas. Tente novamente.");
    }
  };

  useEffect(() => {
    const canvas = document.getElementById("rainCanvas");
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const w = window.innerWidth;
    const h = window.innerHeight;
    canvas.width = w;
    canvas.height = h;

    const numDrops = 100;
    const drops = Array.from({ length: numDrops }, () => ({
      x: Math.random() * w,
      y: Math.random() * h,
      l: 10 + Math.random() * 20,
      xs: -2 + Math.random() * 4,
      ys: 4 + Math.random() * 4,
    }));

    function draw() {
      if (!ctx) return;
      ctx.clearRect(0, 0, w, h);
      ctx.strokeStyle = "rgba(255,255,255,0.3)";
      ctx.lineWidth = 1;
      ctx.beginPath();
      for (let i = 0; i < numDrops; i++) {
        const d = drops[i];
        ctx.moveTo(d.x, d.y);
        ctx.lineTo(d.x + d.xs, d.y + d.l);
      }
      ctx.stroke();
      move();
    }

    function move() {
      for (let i = 0; i < numDrops; i++) {
        const d = drops[i];
        d.x += d.xs;
        d.y += d.ys;
        if (d.x > w || d.y > h) {
          d.x = Math.random() * w;
          d.y = -20;
        }
      }
    }

    const interval = setInterval(draw, 30);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <style>{`
    body {
      margin: 0;
      padding: 0;
      filter: grayscale(1);
      overflow: hidden;
    }

    canvas.rain-canvas {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 0;
      pointer-events: none;
    }
  `}</style>

      {/* Canvas da chuva */}
      <canvas id="rainCanvas" className="rain-canvas" />

      {/* Mensagem centralizada */}
      <Center h="100vh" position="relative" zIndex={1}>
        <Box
          bg="whiteAlpha.800"
          p="10"
          borderRadius="lg"
          boxShadow="2xl"
          textAlign="center"
          maxW="lg"
          backdropFilter="blur(4px)"
        >
          <Heading size="lg" mb="4" color="gray.700">
            😢 Fim de uma era...
          </Heading>
          <Text fontSize="md" mb="4" color="gray.600">
            Este portal foi desligado com carinho...
          </Text>
          <Text fontSize="sm" mb="6" color="gray.500">
            Ele serviu bem, trabalhou duro... agora está curtindo a
            aposentadoria digital.
          </Text>
          <Text fontSize="md" fontWeight="semibold" mb="6" color="gray.700">
            Mas não tema! A nova geração já está no ar:
          </Text>
          <Box filter="none" zIndex={2} position="relative">
            <Button
              as="a"
              href="https://portal-pes.nexusconsultoriams.com.br"
              target="_blank"
              rightIcon={<FaExternalLinkAlt />}
              bg="purple.500"
              color="white"
              _hover={{ bg: "purple.600" }}
            >
              Ir para o novo portal
            </Button>
          </Box>
        </Box>
      </Center>
    </>
  );
};

export default LoginPage;
